module.exports = __webpack_public_path__ + "static/img/yg_btn2.9c692bb.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/home/pc/role3/control/yg_btn2.png
// module id = cOoM
// module chunks = 7